import React, { useRef } from 'react';
import styled from 'styled-components/macro';
import { useProgress } from '@react-three/drei';

import FooterLinks from '../../components/FooterLinks';
import Tree from './Tree';
import Fruits from './Fruits';
import Birthday from './Birthday';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  background: #006e41;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;
  bottom: 0;
  left: 50%;

  transform: translateX(-50%);

  @media screen and (min-height: 40em) {
    top: 15%;
    bottom: unset;
  }
`;

const Percentage = styled.p`
  width: 80vw;

  text-align: center;
  font-size: 65rem;
  line-height: 65rem;
  font-family: 'Dancing Script', cursive;
  color: white;
`;

const Mask = styled.div`
  position: absolute;
  z-index: 5;
  height: 100%;
  width: 100%;

  background: #eee;
  opacity: 0;
  display: none;
`;

const Loading = ({ onContinue }: { onContinue: () => void }) => {

  const { progress } = useProgress();

  const wrapper = useRef<HTMLDivElement>(null);
  const mask = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLDivElement>(null);

  useAnimation(wrapper, mask);

  return (
    <Wrapper
      ref={wrapper}
      onWheel={e => e.stopPropagation()}
      onTouchStart={e => e.stopPropagation()}
    >
      <Container>
        <Tree progress={progress} />
        <Fruits loaded={progress === 100} />

        {progress !== 100 &&
          <Percentage>
            {progress.toFixed(0)}%
          </Percentage>
        }

        {progress === 100 &&
          <Birthday onContinue={onContinue} />
        }
      </Container>

      <Mask ref={mask} />

      <FooterLinks ref={ref} bottom={1} color="white" />
    </Wrapper>
  );
}

export default React.memo(Loading);